module.exports = __webpack_public_path__ + "img/google-play.93bda21e.svg";